<!-- <iframe #iframe (load)="start()" width="100%" allow="geolocation *; microphone *; camera *;" *ngIf="showIframe"></iframe> -->
<iframe [hidden]="!showIframe" #iframe width="100%" allow="geolocation *; microphone *; camera *;"></iframe>

<alert type="danger" *ngIf="!showIframe && showError">
  <strong>{{ 'MISSING_PARAMS_TITLE' | translate }}</strong> {{ 'MISSING_PARAMS_TEXT' | translate }}
</alert>

<ng-template #template>
  <div class="modal-header text-center text-white text-center p-4" [ngClass]="[ backgroundColor ]">
    <fa-icon [icon]="modalIcon" size="6x" class="d-block m-auto"></fa-icon>
  </div>
  <div class="modal-body text-center">
    <h4 class="mt-3" [innerHTML]="finalModalTitleText"></h4>
    <p [innerHTML]="finalModalText" [ngClass]="[finalModalTextSize]"></p>
    <button type="button" class="btn btn-link mt-3" (click)="redirectOnConfirmation()" >{{ 'CONTINUE' | translate }}&nbsp;<fa-icon [icon]="arrowIcon"></fa-icon></button>
  </div>
</ng-template>
